// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"afd91aab","156":"b99e58c8","347":"bf76837f","448":"d11cf47e","478":"e06ce3a2","626":"b9365be9","734":"2f574546","819":"2c112646"}[chunkId] + ".chunk.js";
};